import { Component, Input } from '@angular/core';
import subcategoryDescription from '../../../../assets/subcategory-descriptions/subcategory-descriptions.json';
import { PrimeNGModule } from '../../../primeng.module';
import InfoSubCategory from '../../models/product/info-sub-category';
import { SharedModule } from '../../shared.module';

export class SubcategoryDescription {
  public id?: string;
  public format?: string;
  public descriptions?: SubcategoryDescriptionItem;
  public faqs?: SubcategoryFaqItem[];
}

export class SubcategoryDescriptionItem {
  public title?: string;
  public text?: string;
  public sections?: SubcategoryDescriptionSectionItem[];
}

export class SubcategoryFaqItem {
  public question?: string;
  public answer?: string;
}

export class SubcategoryDescriptionSectionItem {
  public subtitle?: string;
  public text?: string;
}

@Component({
  selector: 'app-subcategory-description',
  standalone: true,
  imports: [SharedModule, PrimeNGModule],
  templateUrl: './subcategory-description.component.html',
  styleUrl: './subcategory-description.component.scss',
})
export class SubcategoryDescriptionComponent {
  @Input()
  public set subCategory(subCategory: InfoSubCategory | undefined) {
    if (subCategory) {
      this.setDescription(subCategory);
    }
  }

  public catSelected?: SubcategoryDescription;

  setDescription(subCategory: InfoSubCategory) {
    this.catSelected = undefined;
    if (subcategoryDescription) {
      let sub = subcategoryDescription.find(
        (info) => info.id === subCategory.id
      );

      if (sub) {
        const info: SubcategoryDescription = Object.assign(
          new SubcategoryDescription(),
          sub
        );
        info.format = !info.format ? 'plain' : info.format;
        this.catSelected = info;
      }
    }
  }
}
